<template lang="pug">
  component(:is="$rogue.featureFlags.isOn('rfk_fallback') ? CategoryFallback : Category")
</template>
<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import Category from './category.vue'

const CategoryFallback = defineAsyncComponent(() => import(/* webpackChunkName: "pf-category-fallback" */ './fallback.vue'))
</script>
